import baseApi from '@store/api/baseApi';

export const moodBoardApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchMoodBoards: builder.query({
			query: (params) => `/trend-mood-board${params}`,
			providesTags: ['MoodBoards']
		}),
		addMoodBoard: builder.mutation({
			query: (requestBody) => ({
				url: `/trend-mood-board/add`,
				method: 'POST',
				body: requestBody
			}),
			invalidatesTags: ['MoodBoards']
		}),
		findMoodBoardById: builder.query({
			query: (params) => `/trend-mood-board${params}`,
			providesTags: ['MoodBoardTags']
		}),
		fetchMoodBoardTags: builder.query({
			query: (params) => `/tags/all${params}&entityActivityType=PRODUCT_TAG_UPDATE`,
			providesTags: ['MoodBoardTags']
		})
	})
});

export const {
	useFetchMoodBoardsQuery,
	useAddMoodBoardMutation,
	useFindMoodBoardByIdQuery,
	useFetchMoodBoardTagsQuery
} = moodBoardApi;
